export default {
  method: 'get', 
  baseURL: SERVICE_URL,
  headers: {'x-requested-with': 'XMLHttpRequest'},
  // data: {},
  timeout: 5000,
  withCredentials: !(SERVICE_URL.indexOf('mock.kuaidadi.com') > 0)
  // withCredentials: false // 设置 mock 的时候要启用
  // responseType: 'json'
}
export const customConfig = {
  'redirectUri': REDIRECT_URL
}
